import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { AuthPageSettingHttpService } from '../services';
import { authPageSettingActions } from '../actions';


@Injectable()
export class AuthPageSettingEffects {

    constructor(
        private actions$: Actions,
        private AuthPageSettingHttpService: AuthPageSettingHttpService
    ) { }

    
    loadEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<authPageSettingActions.Load>(authPageSettingActions.ActionTypes.LOAD),
        switchMap((action: authPageSettingActions.Load) => {
            return this.AuthPageSettingHttpService.load(action.companyId).pipe(
                map((respone) => {
                    return new authPageSettingActions.LoadSuccess(respone);
                }),
                catchError((error: any) => {
                    return of(new authPageSettingActions.LoadFail(error));
                }));
        })
    ));

    
    updateEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<authPageSettingActions.Update>(authPageSettingActions.ActionTypes.UPDATE),
        switchMap((action: authPageSettingActions.Update) => {
            return this.AuthPageSettingHttpService.update(action.companyId, action.payload).pipe(
                map(() => {
                    return new authPageSettingActions.UpdateSuccess();
                }),
                catchError((error: any) => {
                    return of(new authPageSettingActions.UpdateFailure(error));
                }))
        })
    ));
}